import {
  AuctionBiddingEngine,
  EAuctionBiddingEngine,
  LotSymbol,
} from '@bonhams1793/bonhams-typescript'

import { decodeHtml } from '@nx/decode-html'
import { SmartlingAttributes } from '@nx/smartling'
import { getTranslate } from '@nx/translations'

import {
  StyledLotCardTitleContainer,
  StyledLotCardTitleHeading,
  StyledLotCardTitleOuterContainer,
  StyledLotCardTitleStatus,
  StyledLotSymbol,
} from './LotCardTitle.styles'
import translate from './LotCardTitle.translate.json'

const { text } = getTranslate(translate)

export function LotCardTitle({
  lotId,
  styledDescription,
  title,
  symbols,
  heading,
  isShowingLotId,
  biddingEngine,
  isExhibition,
  isPreview,
  ...props
}: LotCardTitleProps) {
  const comingSoon = isPreview && !isExhibition
  const symbol = symbols.map(({ symbol }) => decodeHtml(symbol)).join()

  return (
    <StyledLotCardTitleOuterContainer {...props}>
      {heading && (
        <StyledLotCardTitleHeading
          as="span"
          $level="XS"
          data-testid="lot-card-title-heading"
          {...SmartlingAttributes.noTranslate}
        >
          {heading}
        </StyledLotCardTitleHeading>
      )}
      {(biddingEngine === AuctionBiddingEngine.BRK ||
        biddingEngine === AuctionBiddingEngine.BUK) && (
        <StyledLotCardTitleHeading as="span" $level="XS" $isDivider={!!heading}>
          {text('lotCardTitle.offered', {
            brand:
              biddingEngine === AuctionBiddingEngine.BRK
                ? 'Bruun Rasmussen'
                : 'Bukowskis',
          })}
        </StyledLotCardTitleHeading>
      )}
      {comingSoon && (
        <StyledLotCardTitleStatus $level="XS">
          {text('lotCardTitle.soon')}
        </StyledLotCardTitleStatus>
      )}
      <StyledLotCardTitleContainer
        as="h3"
        $level={6}
        {...SmartlingAttributes.noTranslate}
      >
        {!comingSoon && isShowingLotId && (
          <StyledLotSymbol
            title={symbols
              .map(({ longDescription }) => decodeHtml(longDescription))
              .join(' ')}
          >
            {lotId}
            <sup>{symbol}</sup> —{' '}
          </StyledLotSymbol>
        )}
        <span
          dangerouslySetInnerHTML={{
            __html: styledDescription ? styledDescription : title,
          }}
        />
      </StyledLotCardTitleContainer>
    </StyledLotCardTitleOuterContainer>
  )
}

export interface LotCardTitleProps {
  lotId: string
  styledDescription?: string
  title: string
  symbols: LotSymbol[]
  heading: string
  isShowingLotId: boolean
  biddingEngine: EAuctionBiddingEngine
  isExhibition: boolean
  isPreview: boolean
}
